/**
 * Read More/Read Less Global Functionality
 * Handles expandable text content across the theme
 */

class ReadMoreManager {
  constructor() {
    this.init();
  }

  init() {
    this.initializeReadMore();
    this.setupObserver();
  }

  initializeReadMore() {
    const readMoreContainers = document.querySelectorAll('[data-read-more]');
    
    readMoreContainers.forEach(container => {
      if (container.dataset.initialized) return;
      
      const toggle = container.querySelector('[data-toggle]');
      const preview = container.querySelector('[data-preview]');
      const fullText = container.querySelector('[data-full]');
      const moreText = toggle?.querySelector('.toggle-more');
      const lessText = toggle?.querySelector('.toggle-less');
      
      if (!toggle || !preview || !fullText || !moreText || !lessText) return;
      
      // Mark as initialized
      container.dataset.initialized = 'true';
      
      toggle.addEventListener('click', (e) => this.handleToggle(e, {
        toggle,
        preview,
        fullText,
        moreText,
        lessText
      }));
    });
  }

  handleToggle(event, elements) {
    event.preventDefault();
    
    const { toggle, preview, fullText, moreText, lessText } = elements;
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      // Collapse - show preview, hide full text
      preview.classList.remove('hidden');
      fullText.classList.add('hidden');
      moreText.classList.remove('hidden');
      lessText.classList.add('hidden');
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      // Expand - hide preview, show full text
      preview.classList.add('hidden');
      fullText.classList.remove('hidden');
      moreText.classList.add('hidden');
      lessText.classList.remove('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  setupObserver() {
    // Watch for dynamically added content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const readMoreElements = node.querySelectorAll ? 
                node.querySelectorAll('[data-read-more]') : [];
              
              if (readMoreElements.length > 0) {
                this.initializeReadMore();
              }
              
              // Check if the added node itself is a read-more element
              if (node.dataset && node.dataset.readMore !== undefined) {
                this.initializeReadMore();
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Public method to reinitialize (useful for AJAX content)
  reinitialize() {
    this.initializeReadMore();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.readMoreManager = new ReadMoreManager();
});

// Export for manual reinitialization
window.reinitReadMore = () => {
  if (window.readMoreManager) {
    window.readMoreManager.reinitialize();
  }
};